import { motion } from "framer-motion";
import { Building, ArrowRight } from "lucide-react";

export default function About() {
    return (
        <section
            id="about"
            data-testid="about-section"
            className="relative py-24 md:py-32 bg-ae-gray-100"
        >
            <div className="max-w-7xl mx-auto px-6 md:px-10">
                <div className="grid lg:grid-cols-12 gap-12 lg:gap-20 items-start">
                    <motion.div
                        initial={{ opacity: 0, y: 24 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        viewport={{ once: true, margin: "-80px" }}
                        transition={{ duration: 0.8 }}
                        className="lg:col-span-5"
                    >
                        <div className="inline-flex items-center gap-2 text-ae-orange text-xs font-bold uppercase tracking-[0.22em]">
                            <Building className="h-4 w-4" />
                            Company Profile
                        </div>
                        <h2 className="mt-5 font-display font-extrabold text-4xl md:text-5xl lg:text-6xl text-ae-ink tracking-tight leading-[1.02]">
                            The forward-facing brand of{" "}
                            <span className="text-ae-orange">Amplified eSolutions</span>.
                        </h2>
                    </motion.div>

                    <motion.div
                        initial={{ opacity: 0, y: 24 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        viewport={{ once: true, margin: "-80px" }}
                        transition={{ duration: 0.8, delay: 0.1 }}
                        className="lg:col-span-7"
                    >
                        <div className="space-y-5 text-base md:text-lg text-ae-gray-700 leading-relaxed">
                            <p>
                                AE is an{" "}
                                <strong className="text-ae-ink">
                                    AI-enhanced advertising agency
                                </strong>{" "}
                                built to help brands turn ideas into measurable digital and
                                real-world impact. Our story began in 2014 as Digital
                                2wist Inc., and evolved in 2017 into Amplified eSolutions
                                Inc., bringing together advertising, creative, media,
                                software, analytics and activation expertise.
                            </p>
                            <p>
                                Today, AE integrates AI across planning, creative
                                development, digital advertising, content, websites,
                                software applications, analytics and digitally enhanced
                                interactive activations — our specialty. With more than 26
                                years of combined team experience, AE helps brands amplify
                                everything:{" "}
                                <span className="text-ae-ink font-semibold">
                                    strategy, campaigns, experiences, technology and
                                    results.
                                </span>
                            </p>
                        </div>

                        <div className="mt-10 grid sm:grid-cols-2 gap-4">
                            <div
                                className="rounded-2xl bg-white border border-black/5 p-5 shadow-ae-soft"
                                data-testid="about-pillar-creative"
                            >
                                <div className="text-xs uppercase tracking-[0.2em] font-bold text-ae-orange">
                                    Creative + Tech
                                </div>
                                <div className="mt-2 font-display font-bold text-lg text-ae-ink">
                                    Where ideas meet AI-augmented execution.
                                </div>
                            </div>
                            <div
                                className="rounded-2xl bg-white border border-black/5 p-5 shadow-ae-soft"
                                data-testid="about-pillar-results"
                            >
                                <div className="text-xs uppercase tracking-[0.2em] font-bold text-ae-orange">
                                    Measurable Results
                                </div>
                                <div className="mt-2 font-display font-bold text-lg text-ae-ink">
                                    Every campaign tied to performance metrics.
                                </div>
                            </div>
                        </div>

                        <a
                            href="#services"
                            data-testid="about-cta-services"
                            className="mt-10 inline-flex items-center gap-2 text-ae-ink font-semibold hover:text-ae-orange transition-colors"
                        >
                            Explore what we do
                            <ArrowRight className="h-4 w-4 group-hover:translate-x-1 transition-transform" />
                        </a>
                    </motion.div>
                </div>
            </div>
        </section>
    );
}
